module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/102/assets/images/63eb4f0c0787c6b3a764c4e4efb65239.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_last_activity.svg
// module id = 4VlO
// module chunks = 0